import { UserMemberStatusDto } from '@act/shared/data-transfer-objects';

export const getStatusColor = (status: UserMemberStatusDto) => {
  if (!status || !status.name) {
    return 'error';
  }

  switch (status?.key) {
    case 'queued':
    case 'newly-engaged':
    case 're-engaged':
      return 'success';
    case 'misconduct':
    case 'refused-services':
      return 'error';
    case 'interacted':
    case 'attempted':
      return 'warning';
    default:
      return 'neutral';
  }
};

export const isStatusSaturated = (status: UserMemberStatusDto) => {
  if (!status || !status.name) {
    return false;
  }

  switch (status?.key) {
    case 'misconduct':
    case 'new':
    case 'newly-engaged':
    case 'queued':
    case 're-engaged':
      return true;
    default:
      return false;
  }
};
